import React from 'react';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { EarningsIcon } from '../icons/EarningsIcon';
import { ComparePreset } from '../../model/datePicker/types';

const Earnings = ({ value, previousValue, comparePreset }: Props) => {
  return (
    <div className="d-flex flex-column">
      <small className="mb-2 text-gray-12">Earnings</small>
      <div className="d-flex align-items-center">
        <EarningsIcon />
        <h1 className="ms-2 mb-0 text-gray-12">{value.toFixed(2)}€</h1>
      </div>
      <div className="mt-2">
        <small className="d-flex align-items-center" style={{ marginTop: 1 }}>
          <Diff value={getDiff(value, previousValue)} />
          <div className="text-gray-12 fs-7">{getComparePresetLabel(comparePreset)} ({previousValue.toFixed(2)}€)</div>
        </small>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  previousValue: number,
  comparePreset?: ComparePreset
}

export { Earnings };